import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";
import contributorConstants from "../constants/contributorConstants";

const initialState = {
  contributors: [],
  artists: [],
  allArtists: [],
  artistCount: 0,
  lyricists: [],
  allLyricists: [],
  lyricistCount: 0,
  composers: [],
  allComposers: [],
  composerCount: 0,
  error: false,
  pending: false,
  fulfilled: false,
  contributorsPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case contributorConstants.GET_CONTRIBUTORS_LIST:
      return {
        ...state,
        contributorsPending: true,
      };
    case contributorConstants.GET_CONTRIBUTORS_LIST_SUCCESS:
      return {
        ...state,
        contributors: action.payload.data.results,
      };
    case contributorConstants.ADD_CONTRIBUTOR_REQ:
    case contributorConstants.EDIT_CONTRIBUTOR_REQUEST:
    case contributorConstants.DELETE_CONTRIBUTOR_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case contributorConstants.ADD_CONTRIBUTOR_REQ_SUCCESS:
    case contributorConstants.EDIT_CONTRIBUTOR_SUCCESS:
    case contributorConstants.DELETE_CONTRIBUTOR_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case contributorConstants.ADD_CONTRIBUTOR_REQ_FAILURE:
    case contributorConstants.EDIT_CONTRIBUTOR_FAILURE:
    case contributorConstants.DELETE_CONTRIBUTOR_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };
    case contributorConstants.GET_ARTISTS_LIST_SUCCESS:
      if (globalUtils.isResultsExistInObj(action.payload.data))
        return {
          ...state,
          contributorsPending: false,
          artistCount: action.payload.data.count,
          artists: action.payload.data.results,
        };
      return { ...state, allArtists: action.payload.data };
    case contributorConstants.GET_LYRICISTS_LIST_SUCCESS:
      if (globalUtils.isResultsExistInObj(action.payload.data))
        return {
          ...state,
          contributorsPending: false,
          lyricistCount: action.payload.data.count,
          lyricists: action.payload.data.results,
        };
      return { ...state, allLyricists: action.payload.data };
    case contributorConstants.GET_COMPOSERS_LIST_SUCCESS:
      if (globalUtils.isResultsExistInObj(action.payload.data))
        return {
          ...state,
          contributorsPending: false,
          composerCount: action.payload.data.count,
          composers: action.payload.data.results,
        };
      return { ...state, allComposers: action.payload.data };

    case contributorConstants.GET_ARTISTS_LIST_FAILURE:
    case contributorConstants.GET_LYRICISTS_LIST_FAILURE:
    case contributorConstants.GET_COMPOSERS_LIST_FAILURE:
      return {
        ...state,
        contributorsPending: false,
      };
    case contributorConstants.RESET_CONTRIBUTORS:
      return {
        ...state,
        artists: [],
        lyricists: [],
        composers: [],
        artistCount: 0,
        lyricistCount: 0,
        composerCount: 0,
        allArtists: [],
        allLyricists: [],
        allComposers: [],
      };
    default:
      return {
        ...state,
      };
  }
};
